export default __webpack_public_path__ + "static/media/30.bb79c2ec.png";